import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import AssignmentSheetComp from "./Component/AssignmentSheetComp"

const AssignmentSheet =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
             <AssignmentSheetComp/>
        </div>
        <Footer />
        </>
    )
}

export default AssignmentSheet